<template>
  <div>
    <search-group
      :multipleLines="true" :inline="true"
      :span="24" :btnOffset="18" :btnSpan="6"
      @search="findData" @clear="clearValue"
    >
      <Row :gutter="18" class="mb16">
        <Col span="5">
          <Select placeholder="请选择项目" v-model="searchData.projectFid" @on-change="changeProject">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <!--<Col span="4">-->
        <!--<Select placeholder="请选择ZO" v-model="searchData.zoFid">-->
        <!--<Option value="">请选择</Option>-->
        <!--<Option v-for="(item,index) in zoList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
        <!--</Select>-->
        <!--</Col>-->
        <Col span="4">
          <DatePicker class="block" type="daterange" placeholder="评价时间" v-model="searchData.evaluateTime"></DatePicker>
        </Col>
        <Col span="5">
          <Select placeholder="ZO服务星级" v-model="searchData.serviceStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option v-for="(item,index) in clist.serviceStar" :value="item.value" :key="'keyB'+index">{{item.text}}
            </Option>

          </Select>
        </Col>
        <Col span="6" class="flex">
          <span class="flexnone">综合评分:</span>
          <InputNumber
            class="flexauto"
            v-model="searchData.sumUpScoreFrom"
            :min="0"
            :precision="1"
            :step="0.1"
            :max="searchData.sumUpScoreTo"
            @on-change="changeFrom1"
          ></InputNumber>-
          <InputNumber
            class="flexauto"
            v-model="searchData.sumUpScoreTo"
            :min="searchData.sumUpScoreFrom"
            :max="5"
              :step="0.1"
              :precision="1"
            @on-change="changeTo1"
          ></InputNumber>
        </Col>
        <Col span="4">
          <Select placeholder="维修服务星级" v-model="searchData.maintainStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option v-for="(item,index) in clist.maintainStar" :value="item.value" :key="'keyC'+index">{{item.text}}
            </Option>
          </Select>
        </Col>

      </Row>

      <Row :gutter="12" class="mb16">
                <Col span="4" style="position: relative;">
          <!--<Select placeholder="关键字查询" v-model="searchKey">-->
          <!--<Option value="">请选择</Option>-->
          <!--<Option v-for="(item,index) in keyList" :value="item.value" :key="'keyE'+index">{{item.text}}-->
          <!--</Option>-->
          <!--</Select>-->
          <Input v-model="searchData.contractCode" placeholder="请输入合同号"/>
          <!--
          <span style="position: absolute;left: 10px;top: 35px;" class="error-color"  v-if="searchData.contractCode">企业合同请输入主合同号</span>
          -->
        </Col>
        <Col span="4">
          <Select placeholder="保洁服务星级" v-model="searchData.cleaningStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option v-for="(item,index) in clist.cleaningStar" :value="item.value" :key="'keyD'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="安保服务星级" v-model="searchData.securityStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option v-for="(item,index) in clist.securityStar" :value="item.value" :key="'keyE'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="社区氛围星级" v-model="searchData.atmosphereStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option v-for="(item,index) in clist.atmosphereStar" :value="item.value" :key="'keyE'+index">{{item.text}}
            </Option>
          </Select>
        </Col>

        <Col span="4">
          <Select placeholder="推荐分值" v-model="searchData.recommendStar" :multiple="true">
            <!--<Option value="">请选择</Option>-->
            <Option v-for="(item,index) in clist.recommendStar" :value="item.value" :key="'keyE'+index">{{item.text}}
            </Option>

          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="请选择是否显示" v-model="searchData.isShow" >
              <Option value="">请选择</Option>
            <Option
              v-for="(item,index) in clist.showOrHide"
              :value="item.value"
              :key="'keyC'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>

        <!--
        <Col span="4" style="position: relative;">
          &lt;!&ndash;<Select placeholder="关键字查询" v-model="searchKey">&ndash;&gt;
          &lt;!&ndash;<Option value="">请选择</Option>&ndash;&gt;
          &lt;!&ndash;<Option v-for="(item,index) in keyList" :value="item.value" :key="'keyE'+index">{{item.text}}&ndash;&gt;
          &lt;!&ndash;</Option>&ndash;&gt;
          &lt;!&ndash;</Select>&ndash;&gt;
          <Input v-model="searchData.contractCode" placeholder="请输入合同号"/>
          &lt;!&ndash;
          <span style="position: absolute;left: 10px;top: 35px;" class="error-color"  v-if="searchData.contractCode">企业合同请输入主合同号</span>
          &ndash;&gt;
        </Col>-->
        <!--<Col span="4" v-if="searchData.contractCode">-->
        <!--&lt;!&ndash;<Select placeholder="关键字查询" v-model="searchKey">&ndash;&gt;-->
        <!--&lt;!&ndash;<Option value="">请选择</Option>&ndash;&gt;-->
        <!--&lt;!&ndash;<Option v-for="(item,index) in keyList" :value="item.value" :key="'keyE'+index">{{item.text}}&ndash;&gt;-->
        <!--&lt;!&ndash;</Option>&ndash;&gt;-->

        <!--</Col>-->
      </Row>
    <Row :gutter="12">
          <Col span="4">
          <Select placeholder="请选择评价内容" v-model="searchData.isHaveSuggest" >
              <Option value="">请选择</Option>
            <Option
              v-for="(item,index) in clist.isHaveSuggest"
              :value="Number(item.value)"
              :key="'keyD'+index"
            >{{item.text}}</Option>
          </Select>
        </Col>
      </Row>
    </search-group>
    <Button class="mb16" type="primary" @click.stop="exportEvalution" :loading="buttonloading"
            v-p="{api:'evaluate/exportEvaluateList'}">导出评价</Button>
    <table-list
      title="" :columns="columns" :data="data"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
    <img-show :n="imgN" :src="imgSrc"></img-show>
  </div>

</template>

<script>
  import TableList from "components/TableList/index";
  import SearchGroup from 'components/SearchGroup/index';
  import {getProjectZos} from "../../../../api/common";
  import {formatDateTime} from "../../../../utils/format";
  import {
    getEvaluateList,
    getEvaluateModuleDetail,
    getExportEvaluateCount,
    exportEvaluateList,
     toggleDisplay
  } from "../../../../api/evaluation";
  import ImgShow from 'components/ImgListShow/index'
  import {deepClone} from "../../../../utils/format";

  export default {
    name: "SearchList2",
    props: {
      conditionList: {
        type: Object,
        default: () => {
          return {}
        }
      },
      projectList: {
        type: Array,
        default: () => {
          return []
        }
      },
      keyList: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    components: {
      SearchGroup,
      TableList,
      ImgShow
    },
    computed: {
      clist() {
        return {

          recommendStar: this.conditionList.recommendStar || [],
          atmosphereStar: this.conditionList.atmosphereStar || [],
          securityStar: this.conditionList.securityStar || [],
          serviceStar: this.conditionList.serviceStar || [],
          maintainStar: this.conditionList.maintainStar || [],
          cleaningStar: this.conditionList.cleaningStar || [],
          showOrHide: this.conditionList.showOrHide || [],
         isHaveSuggest: this.conditionList.isHaveSuggest || []
        }
      }

    },
    data() {
      return {
        buttonloading: false,
        imgSrc: [],
        imgN: 0,
        searchKey: '',
        loading: false,
        userInput: '',
        data: [],
        total: 0,
        current: 1,
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: "客户详情",
            key: "",
            align: "center",
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.getEvaluateModuleDetail(params.row)
                  }
                }
              }, [h('Icon', {props: {type: 'person'},}, '')])
            },
            width: 100,

          },
          {
            title: ' '
          },
                  {
          width: 85,
          title: "综合评分",
          key: "sumUpScore",
          align: "center"
        },
        {
          title: " "
        },
          {
            title: "zo服务星级",
            key: "serviceStar",
            align: "center",
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "维修服务星级",
            key: "maintainStar",
            align: "center",
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "保洁服务星级",
            key: "cleaningStar",
            align: "center",
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "安保服务星级",
            key: "securityStar",
            align: "center",
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "社区氛围星级",
            key: "atmosphereStar",
            align: "center",
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "评价内容",
            key: "evaluateContent",
            width: 140,
            align: "center",
            render: (h, params) => {
              if (params.row['evaluateContent'] && params.row['evaluateContent'].length > 7) {
                // return h('span',{
                //   attrs:{
                //     title:params.row['evaluateContent']
                //   },
                //   style:{
                //     cursor:'grab'
                //   }
                // },params.row['evaluateContent'].slice(0,10)+'...')

                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['evaluateContent']),
                  h('span', {}, params.row['evaluateContent'].slice(0, 7) + '...')


                ])

              }
              else {
                return h('span', {}, params.row['evaluateContent'])

              }

            }
          },
          {
            title: ' '
          },
          {
            width: 120,
            title: "照片",
            key: "",
            align: "center",
            render: (h, params) => {
              return (params.row['picUrl'] && params.row['picUrl'].length > 0) ? h('a', {
                on: {
                  click: () => {
                    this.imgSrc = params.row['picUrl']
                    this.imgN++
                  }
                }
              }, '查看') : h('span', {}, '无')
            }

          },
          {
            title: ' '
          },
          {
            title: "推荐分值",
            key: "recommendStar",
            align: "center",
            width: 120,
          },
          {
            title: ' '
          },
          {
            width: 140,
            title: "不推荐原因",
            key: "nonSuggest",
            align: "center",
            render: (h, params) => {
              if (params.row['nonSuggest'] && params.row['nonSuggest'].length > 7) {
                // return h('span',{
                //   attrs:{
                //     title:params.row['evaluateContent']
                //   },
                //   style:{
                //     cursor:'grab'
                //   }
                // },params.row['evaluateContent'].slice(0,10)+'...')

                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['nonSuggest']),
                  h('span', {}, params.row['nonSuggest'].slice(0, 7) + '...')


                ])

              }
              else {
                return h('span', {}, params.row['nonSuggest'])

              }
            }

          },
          {
            title: ' '
          },
          {
            title: "评价时间",
            key: "evaluateTime",
            align: "center",
            width: 140,
          },
          {
            title: ' '
          },
          {
            title: "回访详情",
            key: "callBackContent",
            align: "center",
            width: 140,
            render: (h, params) => {
              if (params.row['callBackContent'] && params.row['callBackContent'].length > 7) {
                // return h('span',{
                //   attrs:{
                //     title:params.row['callBackContent']
                //   },
                //   style:{
                //     cursor:'grab'
                //   }
                // },params.row['callBackContent'].slice(0,10)+'...')

                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['callBackContent']),
                  h('span', {}, params.row['callBackContent'].slice(0, 7) + '...')


                ])

              }
              else {
                return h('span', {}, params.row['callBackContent'])

              }

            }

          },
          {
          title: "前端显示",
          key: "evaluateTime",
          align: "center",
          width: 140,
          render: (h, params) => {
            return h("span", params.row.isShow ? "显示" : "隐藏");
          }
        },
               {
          title: " "
        },
          {
          title: "是否显示",
          align: "center",
          width: 100,
          fixed: "right",
          render: (h, params) => {
           const popTitle = !params.row.isShow ? "显示" : "隐藏";
            return [
              h(
                "a",
                {
                  directives: [
                    {
                      name: "p",
                      value: {
                        api: "evaluate/showOrHide"
                      }
                    }
                  ],
                  on: {
                    click: () => {
                       
                      this.$Modal.confirm({
                        title: popTitle + "评价",
                        content: "<p>确认" + popTitle + "本条评价？</p>",
                        onOk: () => {
                          const queryData={
                            evaluateCode: params.row.collectCode,
                            // eslint-disable-next-line no-extra-boolean-cast
                            isShow:+!Boolean(params.row.isShow)
                          }
                          toggleDisplay(queryData).then (res=>{
                            if(res.code === 0){
                              this.$Message.success('状态切换成功')
                             setTimeout(()=>{
                                this.getEvaluateList(this.searchData);
                             },1000)
                            } else{
                              this.$Message.info(res.message)
                            }
                          })
                        }
                      });
                    }
                  }
                },
                popTitle
              )
            ];
          }
        },
				{
          title: ' '
        },
        ],
        searchData: {
          evaluateType: 'ZRYZQ',

          page: 1,
          limit: 10,

          projectFid: '',
          zoFid: '',
          sumUpScoreFrom: 0,
          sumUpScoreTo: 5,
          evaluateTime: '',
          customerName: '',
          customerPhone: '',
          stockNumber: '',
          contractCode: '',
          evaluateTimeFrom: '',
          evaluateTimeTo: '',
          isShow: "",//显示隐藏状态 0隐藏   1显示
          isHaveSuggest: "",
          productStar: [],
          recommendStar: [],
          atmosphereStar: [],
          securityStar: [],
          serviceStar: [],
          maintainStar: [],
          cleaningStar: [],
        },
        searched: null,   // just for  changePage and export
        zoList: []

      }
    },
    methods: {
      exportEvalution() {
        if (this.total === 0) {
          this.$Message.info('数据列表为空！')
          return
        }
        this.buttonloading = true

        getExportEvaluateCount(this.searched).then(() => {

          exportEvaluateList(this.searched).then(res => {

            const fileName = res.headers.filename || 'excel.xls'
            const blob = new Blob([res.data])

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            this.buttonloading = false
            // this.btnLoading = false
          }).catch(() => {
            this.buttonloading = false
          })

        }).catch(() => {
          this.buttonloading = false

        })

      },
      getEvaluateModuleDetail(item) {
        // this.$emit('getdetail',item.businessCode)
          const params = {
            businessCode: item.businessCode,
            evaluateType: 'ZRYZQ'
          }
          getEvaluateModuleDetail(params).then(res => {
            if (!res.data) {
              return
            }
            this.$Modal.confirm({
              render: (h) => {
                const style = {}
                return h('div', {
                  style: {
                    marginTop: '-20px',
                    lineHeight: 2
                  }

                }, [
                  h('h2', {style: {marginBottom: '10px'}}, '客户详情'),
                  h('h3', {}, res.data.projectName),
                  h('p', {}, [h('span', {style: style}, '房间号/床位号：'), h('span', {}, res.data.stockNumber)]),
                  h('p', {}, [h('span', {style: style}, '合同号：    '), h('span', {}, res.data.contractCode)]),
                  h('p', {}, [h('span', {style: style}, '客户名称：   '), h('span', {}, res.data.userName)]),
                  h('p', {}, [h('span', {style: style}, '电话号：    '), h('span', {}, res.data.userPhone)]),
                  h('p', {}, [h('span', {style: style}, '合同租期：   '), h('span', {}, res.data.rentTime)])

                ])
              }
            })


          }).catch(error => {
            console.log(error)
          })


      },
      getEvaluateList(data) {

        data['evaluateTimeFrom'] = formatDateTime(data.evaluateTime[0])
        data['evaluateTimeTo'] = formatDateTime(data.evaluateTime[1])
        getEvaluateList(data).then(res => {
          if (!res.data) {
            return
          }
          this.total = res.data.total
          this.data = res.data.rows
          this.searched = deepClone(data)
        }).catch(error => {
          console.log(error)
        })

      },
      changePage(n) {
        if (!this.searched) {
          this.searched = Object.assign({}, this.searchData)
        }
        this.searched.page = n
        this.current = n
        this.getEvaluateList(this.searched)

      },
      changeProject(value) {
        console.log(value)
        // this.searchData.zoFid = ''
        // if (!value) {
        //   this.zoList = []
        // }
        // else {
        //   this.getProjectZos()
        // }

      },
      changeFrom1(value) {
      if (value > this.searchData.serviceScoreTo) {
        this.searchData.serviceScoreFrom = this.searchData.serviceScoreTo;
      }
    },
    changeTo1(value) {
      if (value < this.searchData.serviceScoreFrom) {
        this.searchData.serviceScoreTo = this.searchData.serviceScoreFrom;
      }
    },
      getProjectZos() {
        getProjectZos(this.searchData.projectFid).then(res => {
          this.zoList = res.data
        }).catch(error => {
          console.log(error)
        })
      },
      findData() {
        this.current = 1
        this.searchData.page = 1
        // this.searchData.stockNumber=''
        // this.searchData.customerName=''
        // this.searchData.contractCode=''
        // if (this.userInput && this.searchKey) {
        //   this.searchData[this.searchKey] = this.userInput
        // }
        this.getEvaluateList(this.searchData)

      },
      clearValue() {
        this.searchKey = ''
        this.userInput = ''
        this.searchData = {
          evaluateType: 'ZRYZQ',
          page: 1,
          limit: 10,
          projectFid: '',
          zoFid: '',
          sumUpScoreFrom: 0,
          sumUpScoreTo: 5,
          evaluateTime: '',
          customerName: '',
          customerPhone: '',
          stockNumber: '',
          contractCode: '',
          isShow: "",//显示隐藏状态 0隐藏   1显示
          isHaveSuggest: "",
          productStar: [],
          recommendStar: [],
          atmosphereStar: [],
          securityStar: [],
          serviceStar: [],
          maintainStar: [],
          cleaningStar: [],
        }
      }
    },
    created() {
      this.getEvaluateList(this.searchData)
    }
  }
</script>

<style scoped>
  .search-wrapper {
    padding: 0;
  }
.flex {
  display: flex;
  align-items: center;
}
.flexnone {
  flex: none;
  padding-right: 10px;
  width: 90px;
}
  .block {
    display: block;
  }

</style>
